'use strict';

const ProductBundles =
  window.ProductBundles != null
    ? window.ProductBundles
    : (window.ProductBundles = {});

if (ProductBundles.Views == null) {
  ProductBundles.Views = {};
}

if (ProductBundles.Views.Bundles == null) {
  ProductBundles.Views.Bundles = require('./views/product_bundles');
}

ProductBundles.init = function({ productBundles }, done) {
  if (!productBundles) {
    return done();
  }

  new ProductBundles.Views.Bundles(productBundles);
  return done();
};

module.exports = ProductBundles;
